/* tslint:disable */
/* eslint-disable */
export enum ProjectStatus {
  NotSet = 'notSet',
  OnTrack = 'onTrack',
  OffTrack = 'offTrack',
  NotStarted = 'notStarted',
  Finished = 'finished',
  Discontinued = 'discontinued'
}
